import { css } from '@mildang/styled-system/css';
import { Button } from '../Button';
import type { ButtonProps } from '../Button/type';

/*
 * Figma Fallback Page 는 버튼이 데스크톱 xl / 모바일 lg 다.
 * recipe `size` 는 반응형이 아니라(생성 타입이 단일 유니온, slot recipe 함수 호출도 반응형 객체를
 * 클래스로 못 만든다) `size={{ base, md }}` 가 타입·런타임 둘 다 불가하다.
 * → Figma 원본이 hidden lg variant 로 모델링한 것과 동일하게, 두 size 를 렌더하고 md 에서 display 로 스왑한다.
 *   `display: contents` 라 래퍼는 레이아웃에 안 잡히고 버튼만 부모 flex 에 참여한다.
 *
 * 이 헬퍼는 Figma 기본값(xl/lg)만 담당한다. **버튼 사이즈를 커스텀하려면 ResponsiveButton 대신
 * FallbackPage 의 `children` 에 `Button` 을 직접 넣어라** — FallbackPage 는 children 으로 아무 ReactNode 나 받는다.
 *   예) <FallbackPage type="notFound"><Button size="md" variant="primary">확인</Button></FallbackPage>
 */
const showMobile = css({ display: 'contents', md: { display: 'none' } });
const showDesktop = css({ display: 'none', md: { display: 'contents' } });

// dual-render(lg/xl 두 버튼을 다 렌더하고 md 에서 스왑)라 요소마다 유니크해야 하는 속성은 받지 않는다.
// - size : recipe 가 반응형이 아니라 여기서 lg/xl 로 직접 나눠 렌더하므로 호출자가 지정하지 못하게 막는다.
// - ref/id : 같은 props 가 두 버튼에 그대로 펼쳐져 ref 타겟이 모호해지거나 DOM 에 id 가 중복된다.
export type ResponsiveButtonProps = Omit<ButtonProps, 'size' | 'ref' | 'id'>;

export function ResponsiveButton(props: ResponsiveButtonProps) {
  return (
    <>
      <span className={showMobile}>
        <Button size="lg" {...props} />
      </span>
      <span className={showDesktop}>
        <Button size="xl" {...props} />
      </span>
    </>
  );
}
